import { Component } from '@theme/component';
import { RecentlyViewed } from '@theme/recently-viewed-products';

class RecentlyViewedSection extends Component {
  async connectedCallback() {
    super.connectedCallback();
    await this.render();
  }

  async render() {
    const productIds = RecentlyViewed.getProducts();
    const currentProductId = this.dataset.productId;
    
    // Filter out current product
    const filteredIds = productIds.filter(id => id !== currentProductId);
    
    if (filteredIds.length === 0) {
      this.classList.add('hidden');
      return;
    }

    const maxProducts = parseInt(this.dataset.maxProducts) || 4;
    const idsToFetch = filteredIds.slice(0, maxProducts);
    
    // Construct search query for multiple IDs
    const query = idsToFetch.map(id => `id:${id}`).join(' OR ');
    const url = `${window.Shopify.routes.root}search?type=product&q=${encodeURIComponent(query)}&view=recently-viewed`;

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Search failed');
      const html = await response.text();
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const items = doc.querySelectorAll('.resource-list__item');

      if (items.length === 0) {
        this.classList.add('hidden');
        return;
      }

      this.classList.remove('hidden');
      const container = this.querySelector('[ref="container"]');
      
      if (this.dataset.layoutType === 'carousel') {
        this.renderCarousel(container, items);
      } else {
        container.innerHTML = html;
      }
      
    } catch (error) {
      console.error('Recently Viewed error:', error);
      this.classList.add('hidden');
    }
  }

  renderCarousel(container, items) {
    let slidesHtml = '';
    items.forEach((item, index) => {
      slidesHtml += `
        <slideshow-slide index="${index}" class="resource-list__slide">
          ${item.outerHTML}
        </slideshow-slide>
      `;
    });

    const iconsStyle = this.dataset.iconsStyle || 'arrow';
    const iconsShape = this.dataset.iconsShape || 'none';
    const showArrows = iconsStyle !== 'none';
    const timelineScope = Array.from({length: items.length}, (_, i) => `--slide-${i}`).join(',');

    container.innerHTML = `
      <slideshow-component
        class="resource-list__carousel"
        style="--slideshow-timeline: ${timelineScope}"
        initial-slide="0"
      >
        <slideshow-container ref="slideshowContainer">
          ${showArrows ? `
            <slideshow-arrows data-icons-style="${iconsStyle}" data-icons-shape="${iconsShape}">
               <button type="button" class="slideshow-control slideshow-control--prev" ref="prev">
                 <span class="visually-hidden">Previous</span>
                 <div class="svg-wrapper flip-x">
                   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                 </div>
               </button>
               <button type="button" class="slideshow-control slideshow-control--next" ref="next">
                 <span class="visually-hidden">Next</span>
                 <div class="svg-wrapper">
                   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                 </div>
               </button>
            </slideshow-arrows>
          ` : ''}
          <slideshow-slides
            tabindex="-1"
            ref="scroller"
            ${this.dataset.sectionWidth === 'page-width' ? 'gutters="start end"' : ''}
          >
            ${slidesHtml}
          </slideshow-slides>
        </slideshow-container>
      </slideshow-component>
    `;
  }
}

if (!customElements.get('recently-viewed-section')) {
  customElements.define('recently-viewed-section', RecentlyViewedSection);
}
